<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="fqc_code,fqc_prodcode"
      placeholder="输入单据编号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/qc/qa/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.fqc_prodcode}}</p>
          <p class="list-item-muted">{{item.fqc_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.fqc_status!='已审核'}"
          >{{item.fqc_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/qc/makefqc/list",
      filters: [
        {
          type: "date",
          name: "fqc_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待判定",
              condition: "fqc_status!='已审核' and fqc_type != '全检'"
            },
            {
              value: 2,
              label: "待入库",
              condition: "fqc_status='已审核' and (fqc_okturnstatus ='未入库' and fqc_okqty > 0)"
            },
            {
              value: 3,
              label: "待全检",
              condition: "fqc_status!='已审核' and fqc_type = '全检'"
            },
            {
              value: 4,
              label: "待返修",
              condition: "fqc_status='已审核' and (fqc_type ='全检' and fqc_rwqty > 0) and fqc_rwturnstatuscode = 'UNTURNIN'"
            },
            {
              value: 5,
              label: "待报废",
              condition: "fqc_status='已审核' and (fqc_type ='全检' and fqc_ngqty > 0) and fqc_ngturnstatuscode = 'UNTURNIN'"
            }
          ]
        }
      ]
    };
  }
};
</script>